var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center text-sm gap-1",class:_vm.color},[_c('span',{staticClass:"iconify svg--circle-full text-xxs m-1"}),_vm._v("\n\n  "+_vm._s(_vm.$t(("" + _vm.stockInformation), {stockCount: _vm.stockCount}))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }